import { render } from "./research-equipment-detail-view.vue?vue&type=template&id=f1e50be2&ts=true"
import script from "./research-equipment-detail-view.vue?vue&type=script&lang=ts"
export * from "./research-equipment-detail-view.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/univerza-maribor/brium/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__